import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
        "& .MuiTableCell-root": {
            border: "1px solid rgba(224, 224, 224, 1)" // Adjust border style as needed
        }
    }
});

const WorklogReportContent = ({ dates, month, year, resource, FetchDetails }) => {

    const [logs, setLogs] = useState([]);
    const loadLogs = async () => {
        const resp = await FetchDetails(`/api/worklogs/report/data/${resource?.id}/${year}/${month-1}`);
        if (resp.status) {
            setLogs(resp.data.data);
        }
    }

    useEffect(() => {
        loadLogs().then();
    }, [month, year, resource]);


    let used = [];



    const classes = useStyles();

    return <div style={{ height: "100%" }}>
        <Paper sx={{ width: '100%', height: '100%' }}>
            <TableContainer>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            {dates.map(v => <TableCell>{v.label}</TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {logs.map((log, index) => {
                            const has = logs.filter((l) => used.filter(v => v.id === l.id).length <= 0);

                            return has.length > 0 && <TableRow>
                                {dates.map(v => {
                                    const filter = logs.filter((l) => (moment(l.startDate).date() === v.label||moment(l.endDate).date() === v.label) && used.filter(v => v.id === l.id).length <= 0);

                                    if (filter.length) {
                                        used.push(filter[0]);
                                    }

                                    return <TableCell>{filter.length ? function () {
                                        let obj = filter[0];
                                        return <div style={{ minWidth: "250px" }}>
                                            <span>{obj?.startDate ? `From ${moment(obj.from, "HH:mm").format("h:mm A")} To ${moment(obj.to, "HH:mm").format("h:mm A")}` : moment(obj.date).format("HH:mm:ss")}</span>
                                            <div className={'font-bold text-blueGray-500'}>[{obj.task?.name ?? obj.project?.name}]</div>
                                            <span className={'text-red-700'}>Duration: {obj.duration?.toLocaleString()} hours</span>
                                            {/* <div>{obj.description}</div> */}
                                            <div
                                                dangerouslySetInnerHTML={{ __html: obj.description }} />
                                        </div>
                                    }() : ''}</TableCell>
                                })}
                            </TableRow>;
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    </div>
}

export default connect(mapStateToProps, mapDispatchToProps)(WorklogReportContent);